import { gql } from "@apollo/client"

export const TOURNAMENT_PLAYER_BY_CODE = gql`
  query TournamentPlayerByCode($input: TournamentPlayerByCodeInput) {
    TournamentPlayerByCode(input: $input) {
      status {
        success
        name
        detail
      }
      personId
      tournamentPlayerId
    }
  }
`
